import { Component, Vue } from "vue-property-decorator";

import { BlankPage, Loading, Hint } from "@/components";
import { Reconciliation, Common } from "@/constant";
import { DepositModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";

// 特店 - 子項目 (每個特店資訊)
type Store = {
    id: number;
    code: string;
    name: string;
    selected: boolean;
};

// 特店 - 主項目 (統編號碼 + 全選)
type StoreGroup = {
    tidNumber: string;
    selected: boolean;
    storeList: Store[];
};

@Component<ReconciliationDepositPrintController>({
    components: {
        BlankPage,
        Hint,
        Loading,
    },
})
export default class ReconciliationDepositPrintController extends Vue {
    private isLoading = false; // 控制顯示header

    // 搜尋引擎 - 空用元件
    private periodMap = Reconciliation.PeriodMap;
    private saleKindMap = Reconciliation.SaleKindMap;
    private minDate = "";
    private maxDate = "";

    private searchItem: {
        storeType: number;
        tidNumber: string;
        storeArr: string[];
        periodType: number;
        start: string;
        end: string;
        saleKindType: number;
        account: string;
    } = {
            storeType: 0,
            tidNumber: "",
            storeArr: [],
            periodType: 1,
            start: "",
            end: "",
            saleKindType: 0,
            account: "",
        };
    private datePeriodStartMax = "";

    // 選取特約清單 => 是否展開LB
    private storeGroupList: StoreGroup[] = [];
    private isOpenStoreLB = false;

    // filter => 依特店彙總, 依入帳號彙總
    private filterType = "store";

    // 列表
    private reconciliationList: TCBReceiptApi.Protobuf.IReconciliation[] = [];
    private reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.create();
    private saleShowMap: { [key: number]: string } = {
        1: '一般',
        2: '境外',
    };
    // 列表 - 依特店彙總
    private byStoreMap: { [k: string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};
    // 列表 - 依入帳彙總
    private byAccountMap: { [k: string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};
    // 列表 - 新版 - 依不同入帳彙總
    private byDiffAccountMap: { [k: string]: { [k:string]: TCBReceiptApi.Protobuf.DepositInfo[] } } = {};    
    // 統計
    private totalObj = TCBReceiptApi.Protobuf.DepositTotal.create();

    // 展開收合
    private isUnfold = false;
    private unfoldList: string[] = [];

    // 展開明細
    private showAllList: string[] = [];

    // 查看明細 => 是否展開LB
    private isOpenDetailLB = false;

    // LB
    private hintBox: { show: boolean, msg: string } = { show: false, msg: "" };

    // 入帳帳號map
    private accountMapByStore: { [storeCode: string]: string } = {};
    private accountMapByAccount: { [storeCode: string]: string } = {};
    private accountMapByDiffAccount: { [account: string]: string } = {}; // 入帳帳號 配對 入帳分行

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        const storageItemJson = localStorage.getItem("FrontReconciliationDeposit") as string;
        if (storageItemJson && storageItemJson !== "") {
            const storageItem = JSON.parse(storageItemJson) as { search: TCBReceiptApi.Protobuf.DepositQuery, filterType: string };
            console.log(storageItem);

            const filterType = storageItem.filterType;
            const searchItem = storageItem.search;
            const depositQuery = TCBReceiptApi.Protobuf.DepositQuery.encode(searchItem).finish();

            this.changeFilter(filterType);
            await this.searchByCondition(depositQuery);
            window.print();
        } else {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.PrintEmptyData]);
            return false;
        }
    }

    /* LB */
    private openHint(msg: string) {
        this.hintBox.msg = msg;
        this.hintBox.show = true;
    }
    private closeHint() {
        this.hintBox.msg = "";
        this.hintBox.show = false;
    }
    /* LB */

    /* 搜尋 */
    private async searchByCondition(depositQuery: Uint8Array) {
        if (depositQuery.length === 0) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.SettingPrintDataError]);
            return false;
        }

        this.isLoading = true;

        /* 取得列表 */
        await DepositModel.getReimbursement(depositQuery);
        const reimbursementList = DepositModel.getReimbursementList();
        this.reconciliationList = reimbursementList.list;
        /* 取得列表 */

        /* 取得展開資料 - map */
        // await DepositModel.getDepositCollectionMap(depositQuery);
        // const depositCollectionMap: TCBReceiptApi.Protobuf.DepositCollectionMap = DepositModel.getDepositCollectionMapData();
        const depositCollectionMap: TCBReceiptApi.Protobuf.DepositCollectionMap = await DepositModel.getPrintDepositCollectionMap(depositQuery);
        console.log("/* 取得展開資料 - map */");
        console.log(depositCollectionMap);
        console.log("/* 取得展開資料 - map */");
        this.countTotalFromMap(depositCollectionMap.map);

        // 第一次預先展開
        this.unfoldList = [];
        Object.keys(depositCollectionMap.map).forEach((thisStoreCode) => {
            this.unfoldList.push(thisStoreCode);
        });
        /* 取得展開資料 - map */

        /* 取得統計 */
        await DepositModel.getDepositTotal(depositQuery);
        const depositTotal = DepositModel.getDepositTotalData();
        this.totalObj = depositTotal;
        /* 取得統計 */

        this.isLoading = false;
    }
    /* 搜尋 */

    /* filter => 依特店彙總, 依入帳號彙總 */
    private async changeFilter(type: string) {
        this.filterType = type;
    }
    /* filter => 依特店彙總, 依入帳號彙總 */

    /* 展開收合 */
    private checkIsUnfold(storeCode: string) {
        let isUnfold = false;
        this.unfoldList.some((thisStoreCode) => {
            if (thisStoreCode === storeCode) {
                isUnfold = true;
                return true;
            }
        });
        return isUnfold;
    }

    private async foldAndUnfoldItem(storeCode: string) {
        const isExist = this.unfoldList.findIndex(
            (thisStoreCode) => thisStoreCode === storeCode
        );

        if (isExist >= 0) {
            // 已經展開
            this.unfoldList.splice(isExist, 1);
        } else {
            // 判斷map是否有對應資料, 有 => 直接加入展開列表, 否 => 動態拿資料回來顯示
            if (!this.byStoreMap[storeCode]) {
                // 整理input
                const item = TCBReceiptApi.Protobuf.DepositQuery.create();
                item.account = this.searchItem.account; // 入帳帳號
                item.type = this.searchItem.periodType; // 日期區間
                item.dateStart = this.searchItem.start; // 起
                item.dateEnd = this.searchItem.end; // 訖
                item.specificStore = storeCode; // 單一特店

                const depositQuery = TCBReceiptApi.Protobuf.DepositQuery.encode(
                    item
                ).finish();

                /* 取得展開資料 */
                await DepositModel.getDepositCollection(depositQuery);
                const depositCollection = DepositModel.getDepositCollectionData();
                const mapItem: { [k: string]: TCBReceiptApi.Protobuf.DepositCollection } = {};
                mapItem[storeCode] = depositCollection;
                this.countTotalFromMap(mapItem);
                /* 取得展開資料 */
            }

            this.unfoldList.push(storeCode);
        }
    }
    /* 展開收合 */

    /* 其他 */
    private isNotNatureNum(val: string) {
        if (val) {
            const num = (val + "").replace(/,/g, "");
            return Number(num) <= 0;
        } else {
            return false;
        }
    }

    // 數字轉千分位 (number to string) ps.保留數字小數點至第二位
    private convertNumberToMoney(num: number) {
        if (!num) {
            return 0;
        }
        let a: string = (num + "").replace(/,/g, "");
        if (a.indexOf(".") != -1) {
            if (a.split(".")[1].length > 2) {
                a = Math.round(+a * 100) / 100 + "";
            }
            if (a.split(".").length == 2) {
                return (+a.split(".")[0]).toLocaleString() + "." + a.split(".")[1];
            } else {
                return (+a.split(".")[0]).toLocaleString();
            }
        } else {
            return (+a.split(".")[0]).toLocaleString();
        }
    }

    // 統計 小計與合計等等資料
    private countTotalFromMap(storeCodeMap: { [k: string]: TCBReceiptApi.Protobuf.IDepositCollection }) {
        if (storeCodeMap) {
            Object.keys(storeCodeMap).forEach(thisStoreCode => {
                /* 依特店彙總 */
                // 遍歷每一個特店
                const storeInfoList: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                // 合計
                const storeTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });

                // 依特店彙總
                const storeDateMenu = storeCodeMap[thisStoreCode].byStore as TCBReceiptApi.Protobuf.DepositDateMap;
                if (storeDateMenu) {
                    const dateMap = storeDateMenu.byDate as { [k: string]: TCBReceiptApi.Protobuf.Deposit };
                    if (dateMap) {
                        Object.keys(dateMap).forEach(thisDate => {
                            // 小計
                            const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                            const infoList = dateMap[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                            infoList.forEach(thisInfo => {
                                // 彙總
                                storeInfoList.push(thisInfo);
                                // 小計
                                subTotalItem.amount += (thisInfo.amount as number);
                                subTotalItem.charge += (thisInfo.charge as number);
                                subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                subTotalItem.netAmount += (thisInfo.netAmount as number);
                                // 合計
                                storeTotalItem.amount += (thisInfo.amount as number);
                                storeTotalItem.charge += (thisInfo.charge as number);
                                storeTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                storeTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                storeTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                storeTotalItem.netAmount += (thisInfo.netAmount as number);

                                this.accountMapByStore[thisStoreCode] = thisInfo.account as string;
                            });

                            storeInfoList.push(subTotalItem);
                        });
                    }

                    // if (storeInfoList.length > 0) {
                    storeInfoList.push(storeTotalItem);

                    this.byStoreMap[thisStoreCode] = storeInfoList;
                    // }
                }
                /* 依特店彙總 */

                /* 依入帳號彙總 */
                // 遍歷每一個特店
                const accountInfoList: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                // 合計
                const accountTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });

                // 依入帳號彙總
                const accountDateMenu = storeCodeMap[thisStoreCode].byAccount as TCBReceiptApi.Protobuf.DepositDateMap;
                if (accountDateMenu) {
                    const dateMap = accountDateMenu.byDate as { [k: string]: TCBReceiptApi.Protobuf.Deposit };
                    if (dateMap) {
                        Object.keys(dateMap).forEach(thisDate => {
                            // 小計
                            const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                            const infoList = dateMap[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                            infoList.forEach(thisInfo => {
                                // 彙總
                                accountInfoList.push(thisInfo);
                                // 小計
                                subTotalItem.amount += (thisInfo.amount as number);
                                subTotalItem.charge += (thisInfo.charge as number);
                                subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                subTotalItem.netAmount += (thisInfo.netAmount as number);
                                // 合計
                                accountTotalItem.amount += (thisInfo.amount as number);
                                accountTotalItem.charge += (thisInfo.charge as number);
                                accountTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                accountTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                accountTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                accountTotalItem.netAmount += (thisInfo.netAmount as number);

                                this.accountMapByAccount[thisStoreCode] = thisInfo.account as string;
                            });

                            accountInfoList.push(subTotalItem);
                        });
                    }

                    // if (accountInfoList.length > 0) {
                    accountInfoList.push(accountTotalItem);

                    this.byAccountMap[thisStoreCode] = accountInfoList;
                    // }
                }
                /* 依入帳號彙總 */

                /* 新版 - 依不同入帳號彙總 */
                const diffAccountInfoList: { [k:string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};

                if (storeCodeMap[thisStoreCode].byDiffAccount) {
                    const depositCollectionMenu = storeCodeMap[thisStoreCode].byDiffAccount as { [k:string]: TCBReceiptApi.Protobuf.DepositDateMap };
                    if (depositCollectionMenu) {
                        Object.keys(depositCollectionMenu).forEach(thisAccount => {
                            const depositDateMap = depositCollectionMenu[thisAccount] as TCBReceiptApi.Protobuf.DepositDateMap;
                            const diffAccountTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });
                            if (depositDateMap) {
                                const depositMenu = depositDateMap.byDate as { [k:string]: TCBReceiptApi.Protobuf.Deposit };
                                Object.keys(depositMenu).forEach(thisDate => {
                                    // 小計
                                    const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                                    const infoList = depositMenu[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                                    infoList.forEach(thisInfo => {
                                        // 彙總
                                        const item: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                                        if (!diffAccountInfoList[thisAccount]) {
                                            diffAccountInfoList[thisAccount] = item;
                                        }
                                        diffAccountInfoList[thisAccount].push(thisInfo);
                                        // 小計
                                        subTotalItem.amount += (thisInfo.amount as number);
                                        subTotalItem.charge += (thisInfo.charge as number);
                                        subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                        subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                        subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                        subTotalItem.netAmount += (thisInfo.netAmount as number);
                                        // 合計
                                        diffAccountTotalItem.amount += (thisInfo.amount as number);
                                        diffAccountTotalItem.charge += (thisInfo.charge as number);
                                        diffAccountTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                        diffAccountTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                        diffAccountTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                        diffAccountTotalItem.netAmount += (thisInfo.netAmount as number);

                                        this.accountMapByDiffAccount[thisAccount] = (thisInfo.branchBankCode as string + " " + thisInfo.branchBankName as string).trim();
                                    });

                                    diffAccountInfoList[thisAccount].push(subTotalItem);
                                })
                            }
                            diffAccountInfoList[thisAccount].push(diffAccountTotalItem);
                        });
                    }
                }

                if (Object.keys(diffAccountInfoList).length > 0) {
                    this.byDiffAccountMap[thisStoreCode] = diffAccountInfoList;
                }

                console.log("/* 新版 - 依不同入帳號彙總 */");
                console.log(this.byDiffAccountMap);
                console.log("/* 新版 - 依不同入帳號彙總 */");
                /* 新版 - 依不同入帳號彙總 */
            });
        }
    }
    /* 其他 */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }
    }
    /* 取得最新的權限map並判斷有何權限 */

    private init() {
        this.byStoreMap = {};
        this.byAccountMap = {};
        this.byDiffAccountMap = {};
    }
}
